jQuery(function($){


  $('#Quantity').change(function() {
   
    console.log($(this).val());

  });

  var urlParams = new URLSearchParams(window.location.search);
  //console.log(urlParams);
  urlParams.delete('page');
  //console.log(urlParams);
  var searchParams = urlParams.toString();
  //console.log(searchParams);
  var url = window.location.pathname;
  if(urlParams.has('view')) {
    if(searchParams != ''){
      url = url + '?' + searchParams;
    } else{
      url = url;
    }
  } else{
    if(searchParams != ''){
      url = url + '?' + searchParams + '&view=all';
    } else{
      url = url + '?view=all';
    }
  }
  if(window.location.pathname.indexOf('introduction') > -1){
    // do nothing
  } else{
    $('.view-all').attr('href', url);
  }
  
  /*if(urlParams.has('sort_by')) { 
    var url = window.location.pathname;
    //var searchParam = window.location.search;
    if(urlParams.has('view')) {
      url = url + '&view=all';
    } else{
      url = url + '&view=all';
    }
    //console.log(url);
    $('.view-all').attr('href', url);
  } */


});